import { render, staticRenderFns } from "./RondaItemCard.vue?vue&type=template&id=0c5cc264&scoped=true"
import script from "./RondaItemCard.vue?vue&type=script&lang=js"
export * from "./RondaItemCard.vue?vue&type=script&lang=js"
import style0 from "./RondaItemCard.vue?vue&type=style&index=0&id=0c5cc264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5cc264",
  null
  
)

export default component.exports